import React from 'react';
import classes from './Notification.module.css';
import { useDispatch, useSelector } from 'react-redux';

import { uiActions } from '../../Redux/ui-slice';

const Notification = (props) => {
    const dispatch = useDispatch();

    let specialClasses = '';

    if (props.status === 'error') {
        specialClasses = classes.error;
    }
    if (props.status === 'success') {
        specialClasses = classes.success;
    }

    const cssClasses = `${classes.notification} ${specialClasses}`;
    const clearNotification = () => {
        dispatch(uiActions.clearNotification());
        props.dismiss();
    };

    return (
        <section className={cssClasses} onClick={clearNotification}>
            <h2>{props.title}</h2>
            <p>{props.message}</p>
        </section>
    );
};

export default Notification;
